import React from 'react';

export default function ServiceNotice (props) {
    return (
        <>
            <strong className="noticeList_title">{props.data.title}</strong>
            <ul className="noticeList">
                {props.data.notice.map((item, index) => (
                    <li key={`service-notice-${index}`} className="noticeList_inner">
                        {item.text}
                        {item.support && (
                            <ol className="numberList">
                                {item.support.map((support, subIndex) => (
                                    <li key={`support-${subIndex}`}>
                                        <span className="num">{support.num}.</span> {support.text}
                                    </li>
                                ))}
                            </ol>
                        )}
                    </li>
                ))}
            </ul>
        </>
    );
}
